import SnapList from './SnapList.vue';
import SnapGame from './SnapGame.vue';

export default {
  SnapList,
  SnapGame,
};
